export default {"src":"/_next/static/media/icon_white.ac4064f6.svg","height":50,"width":35,"blurWidth":0,"blurHeight":0};